import './SingleCareer.scss';


//file on change
const inputElement = document.getElementById("file");
inputElement.addEventListener("change", handleFiles, false);

function handleFiles() {
  const fileList = this.files; /* now you can work with the file list */
  let removeTag = document.querySelector('.file-remove');
  removeTag.classList.add('visible');
  removeTag.innerHTML = fileList[0].name;
}


// delete file
const removeFile = document.querySelector('.file-remove');
removeFile.addEventListener("click", deleteFile, false);

function deleteFile() {
  document.getElementById('file').value = "";
  document.querySelector('.file-remove').classList.remove('visible');
}

ComponentManager.init(document.body);
